
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement("path", { d: "m60.3 4l-.3-.3c-2.3-2.3-6.1-2.3-8.4 0l-10 10.1c-10-6.2-23.3-5-32 3.7-10.1 10.2-10.1 26.7 0 36.8 10.1 10.2 26.6 10.2 36.7 0 8.6-8.6 9.9-21.9 3.9-31.9l10.1-10.1c2.3-2.3 2.3-6 0-8.3m-4.7 8.1c-2.1 0-3.7-1.7-3.7-3.7 0-2.1 1.7-3.7 3.7-3.7s3.7 1.7 3.7 3.7c0 2.1-1.6 3.7-3.7 3.7", fill: "#3e4347" }),
	React.createElement("path", { d: "m12.2 30.1c-4.1 9.1-1.2 19.3 6.6 22.8 7.7 3.5 17.3-1.1 21.4-10.2 4.1-9.1 1.2-19.3-6.6-22.8-7.7-3.5-17.3 1-21.4 10.2", fill: "#fff" }),
	React.createElement("circle", { cx: "23", cy: "36", fill: "#f29a2e", r: "8" })
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/cooking.js
// module id = 688
// module chunks = 0